import { init as headerInit } from './headerComponent';
import { init as footerInit } from './footerComponent';
import { init as sliderInit } from './sliderComponent';
import { init as gocatssDebuggerInit } from './gocatssDebuggerComponent';
import { init as productTileInit } from './productTileComponent';
import { init as productTraySliderInit } from './productTraySliderComponent';
import { init as carouselInit } from './carouselComponent';
import { init as modalShepherdInit } from './modalShepherdComponent';
import { init as tooltipInit } from './tooltipComponent';
import { shouldShowInterstitial } from './countryInterstitialComponent';
import { init as countrySelectInit } from './countrySelectComponent';
import { init as emailSignupMarketingComponent } from './emailSignupMarketingComponent';
import { init as siteMessageInit } from './siteMessageComponent';
import { init as videoComponentInit } from './videoComponent';
import { init as windowComponentInit } from './windowComponent';
import { init as focusComponentInit } from './focusComponent';
import { init as chatWidgetInit } from './chatWidgetComponent';

import {
    saveInitialValues,
    userLoggedIn,
    readyGoogleMaps
} from '../actions/initialActions';

import { debug } from '../utils/logger';
import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import { correctCookies } from '../utils/cookieUtils';
import { usingPwaHeader } from '../utils/headerUtils';
import {
    linkTrackAnalyticsAction,
    inViewTrackAnalyticsAction
} from '../actions/analyticsActions';
import { bindScrollToGaInviewElements } from '@core/js/utils/analyticsUtils';
import { siteSwitchingActive } from '../actions/interstitialActions';
import { modalHashLauncherSaga } from '../sagas/globalModalHashLauncher';

import bindBackToTopSupport from '../uiSupport/backToTop';

import Cookies from '../services/cookies';
import {
    COOKIE_NAME_URBN_LANGUAGE,
    COOKIE_NAME_COUNTRY
} from '../constants';
import { updateHeaderSaga } from '../sagas/headerSagas';

import { initializeTextAreas } from '@core/js/utils/eventUtils';

// window callback for google maps API
function googleMapsApiReady() {
    document.dispatchEvent(new CustomEvent('a15-google-maps-ready'));
}
window.googleMapsApiReady = googleMapsApiReady;

/**
 * Attach component events to DOM
 * @param {Object} store Redux store
 * @returns {undefined}
 */
export function attachEvents(store) {
    const _this = this;

    // TODO: UW-1876 Should this functionality be included in the redux workflow or should it remain as jQuery?
    // TODO: UW-1808 Add functionality to make it so the user is NOT able to Submit when over character -
    // limit but CAN Cancel.
    $(document).on('keyup', '.js-textarea', (e) => {
        const self = e.target;
        const maxCharactersAllowed = $(self).attr('data-max-count');

        const currentNumberOfCharacters = $(self)
                                            .val()
                                            .trim()
                                            .length;

        if (currentNumberOfCharacters <= maxCharactersAllowed) {
            // valid number of characters; make valid
            $(self).removeClass('c-form__textarea--error')
                .siblings('.o-row')
                .find('.js-textarea-remain')
                .removeClass('c-form__hint--invalid')
                .text(maxCharactersAllowed - currentNumberOfCharacters);
        } else {
            // Too many characters entered in field, make invalid
            $(self).addClass('c-form__textarea--error')
                .siblings('.o-row')
                .find('.js-textarea-remain')
                .addClass('c-form__hint--invalid')
                .text(maxCharactersAllowed - currentNumberOfCharacters);
        }
    });

    /**
     * Attach touchend and click events to "show less / show more button" for trucated text component
     * @returns {undefined}
     */
    $(document).on('click', '.js-text-truncate__toggle', (e) => {
        // Toggle hiding of truncated / full text
        $(e.target).closest('.c-text-truncate')
            .children('.c-text-truncate__text')
            .toggleClass('c-text-truncate__hide');
    });

    $(document).on(this.scopedEvent('click'), '[data-ga-link-track]', _.debounce(
        (e) => {
            this.dispatch(linkTrackAnalyticsAction(e, this.name));
        }, 10, {
            leading: true // Invoke function on leading edge of the timeout
        }
    ));

    $(document).on(this.scopedEvent('change'), 'select[data-ga-link-track]', (e) => {
        this.dispatch(linkTrackAnalyticsAction(e, this.name));
    });

    bindScrollToGaInviewElements.bind(this)('[data-ga-inview-track]', (e, element) => {
        this.dispatch(inViewTrackAnalyticsAction(e, element, this.name));
    });

    $(window).on('pageshow', (event) => {
        // browser won't change cookie values (like urbn_language) if the page is retrieved from
        // the browser cache, so we can ensure cookies are updated with the values in the store
        const language = _.get(this.getState(), 'core.language');

        if (language) {
            Cookies.setCookie(COOKIE_NAME_URBN_LANGUAGE, language);
        }
    });

    // Don't init the hashlauncher for pwa_integration
    if (this.feature !== 'pwa') {
        $(window).on('hashchange', (event) => {
            this.runSaga(modalHashLauncherSaga);
        });
    }

    document.addEventListener('a15-cart-core-destroy', function destroyCartCore() {
        debug('eventListener: a15-cart-core-destroy');

        _this.destroyComponent(store);
        // reset core.loggedIn on destroy to bind the account dropdown event when component re-inits
        store.dispatch(userLoggedIn());
        document.removeEventListener('a15-cart-core-destroy', destroyCartCore);
    });

    document.addEventListener('a15-cart-components-ready', function cartComponentsReady() {
        debug('eventListener: a15-cart-components-ready');

        // dispatch saveInitialValues for cart after all components have initialized
        store.dispatch(saveInitialValues());
        document.removeEventListener('a15-cart-components-ready', cartComponentsReady);
    });

    document.addEventListener('a15-google-maps-ready', function googleMapsReady() {
        debug('eventListener: a15-google-maps-ready');

        // let components know that google maps API is good to go
        store.dispatch(readyGoogleMaps());
        document.removeEventListener('a15-google-maps-ready', googleMapsReady);
    });

    if (usingPwaHeader()) {
        document.addEventListener('pwa-get-active-l1', function dispatchCustomEvent() {
            const state = store.getState();
            const currentL1 = _.get(state, 'category.breadcrumbs[0].slug',
                              _.get(state, 'product.productBreadcrumbs[0].slug', ''));
            const pwaEvent = new CustomEvent('pwa-set-active-l1', { detail: currentL1 });
            document.dispatchEvent(pwaEvent);
            document.removeEventListener('pwa-get-active-l1', dispatchCustomEvent);
            // Reinforce font after reset from PWA header orchestration
            document.body.classList.add("mw-fix-pwa-reset");
        });
    }
}

function destroyComponent(store) {
    this.removeAllChildren();
    this.removeEvents(store);
}

function afterConstruction(store) {
    const _this = this;

    if (!this.cart) {
        // Cart Checkout will dispatch this from an event listener
        store.dispatch(saveInitialValues());
    }

    const state = store.getState();
    const integrationTestSettings = window.__urbnIntegrationTestSettings || {};

    correctCookies(state);

    const countryCookie = Cookies.getCookieByName(COOKIE_NAME_COUNTRY);

    store.runSaga(updateHeaderSaga, countryCookie).done.then(() => {
        if (shouldShowInterstitial(state, _.get(integrationTestSettings, 'suppressCountrySwitchModal', false))) {
            if (_this.cart) {
                // Cart Checkout will handle signin with their own modal
                return;
            }

            store.dispatch(siteSwitchingActive(true));

            // TODO move logic in a template so that a render
            // won't overwrite this change
            $('.js-site-wrap').attr('aria-hidden', 'true');
        }
    });

    initializeTextAreas();

    /* Bind Support for Back to top button */
    bindBackToTopSupport(this);
}

export function init(store, overrides = {}) {
    const children = overrides.feature === 'pwa' ? [
        [modalShepherdInit, { feature: 'pwa' }],
        sliderInit,
        carouselInit,
        countrySelectInit,
        videoComponentInit,
        windowComponentInit,
        focusComponentInit,
    ] : [
        headerInit,
        footerInit,
        modalShepherdInit,
        gocatssDebuggerInit,
        emailSignupMarketingComponent,
        sliderInit,
        productTileInit,
        productTraySliderInit,
        carouselInit,
        tooltipInit,
        countrySelectInit,
        siteMessageInit,
        videoComponentInit,
        windowComponentInit,
        focusComponentInit,
        chatWidgetInit
    ];
    const config = {
        children: children,
        name: 'coreComponent',
        attachEvents: attachEvents,
        destroyComponent: destroyComponent,
        afterConstruction: afterConstruction
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
